import React, { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo } from '@fortawesome/free-solid-svg-icons';
import clicksound from './music/click.mp3';

const ButtonRetry = ({ onClick, englishscore }) => {
  // Buat referensi untuk elemen audio
  const audioRef = useRef(null);
  // Fungsi untuk memutar efek suara dan kemudian memanggil onClick
  const handleClick = (event) => {
    englishscore(0);
    if (audioRef.current) {
      audioRef.current.play(); // Mainkan suara klik
    }
    if (onClick) {
      onClick(event); // Panggil fungsi onClick yang diterima sebagai prop
    }
  };

  return (
    <div>
      <button
        className="Retry-button lg:w-14 lg:h-14 sm:w-10 sm:h-10"
        onClick={handleClick}
      >
        <FontAwesomeIcon icon={faUndo} className="lg:text-2xl sm:text-xl" />
      </button>
      <audio ref={audioRef} src={clicksound} />
    </div>
  );
};

export default ButtonRetry;
